<template>
  <div class="echarts" id="housingRightOne"></div>
</template>
<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import { carFlow } from "@/api/dataAnalysis/carAnalysis.js";
import * as echarts from "echarts";
import moment from "moment";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsNameList: [],
      echartsValueList: [],
    });
    const refData = toRefs(data);
    const numberall = async () => {
      const params = {
        startDate: moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format(
          "YYYY-MM-DD 00:00:00"
        ),
        endDate: moment(new Date()).format("YYYY-MM-DD 23:59:59"),
      };
      const res = await carFlow(params);
      if (res.code == 0) {
        res.data.forEach((element) => {
          data.echartsNameList.push(element.name);
          data.echartsValueList.push(element.value);
        });
      }
    };
    onMounted(async () => {
      await numberall();
      const myChart = echarts.init(document.getElementById("housingRightOne"));
      myChart.setOption({
        grid: {
          top: 40,
          left: 50,
          right: 30,
          bottom: 50,
          // containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        xAxis: {
          data: data.echartsNameList,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#08598f", // 横坐标线条颜色
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            // 网格线
            lineStyle: {
              color: "#08598f",
              type: "dashed", // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, // 隐藏或显示
          },
        },
        series: [
          {
            data: data.echartsValueList,
            type: "line",
            smooth: true,
            areaStyle: {
              // 折线图颜色半透明
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#22e8f3", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(34,232,243, 0.1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            itemStyle: {
              normal: {
                color: "#6881cc", // 折点颜色
                lineStyle: {
                  color: "#6881cc", // 折线颜色
                },
              },
            },
          },
        ],
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });

    return {};
  },
});
</script>
<style lang="scss" scoped>
#housingRightOne {
  width: 100%;
  height: 90%;
}
</style>
